import { render, staticRenderFns } from "./Novo-Produto.vue?vue&type=template&id=e880ef76&scoped=true&"
import script from "./Novo-Produto.vue?vue&type=script&lang=js&"
export * from "./Novo-Produto.vue?vue&type=script&lang=js&"
import style0 from "./Novo-Produto.vue?vue&type=style&index=0&id=e880ef76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e880ef76",
  null
  
)

export default component.exports